import * as React from 'react'
import * as constants from 'static/constants'
import { Select } from 'components/atoms'
import styled from 'styled-components'
import { IAssignGuideTourSkill } from 'static/interfaces'
import SvgIcon from 'components/atoms/SvgIcon'
import TourSkillSingleSelect, {
  ITourSkillOption,
} from 'components/molecules/TourSkill/TourSkillSingleSelect'

const { SKILL_LEVELS } = constants

const tourSkillLevelOptions = [{ label: '--', value: '' }].concat(
  Object.keys(SKILL_LEVELS).map(key => {
    const level = key as keyof typeof SKILL_LEVELS

    return {
      value: level,
      label: SKILL_LEVELS[level],
    }
  })
)

interface IProps {
  tourSkills: Array<{ id: number; name: string }>
  assignedTourSkill: IAssignGuideTourSkill
  onChange: (skill: IAssignGuideTourSkill) => void
  onDelete?: () => void
  small?: boolean
}

export const AssignedTourSkillSelector = ({
  tourSkills,
  assignedTourSkill,
  onChange,
  onDelete,
  small = false,
}: IProps) => {
  const tourSkillOptions: ITourSkillOption[] = [{ label: '--', value: '' }].concat(
    tourSkills.map(skill => ({
      label: skill.name,
      value: String(skill.id),
    }))
  )

  return (
    <SelectsWrapper className={small ? 'small' : ''}>
      <div className="selects-container">
        <TourSkillSingleSelect
          className="TourSkillSelect"
          options={tourSkillOptions}
          value={assignedTourSkill?.tour_skill_id || null}
          onChange={(value: string | null) =>
            onChange({ ...assignedTourSkill, tour_skill_id: value || '' })
          }
          placeholder="選択なし"
        />
        <Select
          name="tour_skill_level"
          options={tourSkillLevelOptions}
          value={assignedTourSkill?.level ?? ''}
          onChangeHandler={e => onChange({ ...assignedTourSkill, level: e.target.value })}
        />
        <Select
          name="condition_type"
          options={[
            { label: '以上', value: 'gte' },
            { label: '以下', value: 'lte' },
            { label: 'のみ', value: 'exact' },
          ]}
          value={assignedTourSkill?.condition_type || 'gte'}
          onChangeHandler={e => onChange({ ...assignedTourSkill, condition_type: e.target.value })}
        />
      </div>
      {onDelete && (
        <SvgIcon className="remove-icon" name="remove_circle" role="button" onClick={onDelete} />
      )}
    </SelectsWrapper>
  )
}

const SelectsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-grow: 1;
  &.small {
    .Select_Main {
      ::before,
      ::after {
        border-width: 4px;
      }
      select {
        font-size: 14px;
        height: 32px;
        background-color: ${constants.COLORS.white};
        padding: 2px 28px 2px 8px;
      }
    }
    // react-select overrides
    .css-tlfecz-indicatorContainer,
    .css-1gtu0rj-indicatorContainer {
      padding: 0 8px;
    }
    .tourSkillSingleSelect__control {
      min-height: 32px !important;
      height: 32px !important;
      min-width: 240px;
    }
  }
  .selects-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-grow: 1;
  }
  .TourSkillSelect {
    min-width: 120px;
    font-size: 13px;
    flex-grow: 1;
  }
  .tourSkillSingleSelect__control {
    min-height: 40px;
    border-color: ${constants.COLORS.divider};
  }
  .tourSkillSingleSelect__value-container {
    padding: 2px 12px;
  }
  .remove-icon {
    margin-top: 10px;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    color: ${constants.COLORS.danger};
    cursor: pointer;
  }
`
